import React from 'react';
import { PermissionRestriction } from './Restricted';

type PermissionContextType = {
    isAllowedTo: ({
        allowedRoles,
        creatorsIds,
        permissions
    }: {
        allowedRoles?: string[];
        creatorsIds?: number[];
        permissions?: PermissionRestriction | PermissionRestriction[];
    }) => boolean;
};

const defaultBehaviour: PermissionContextType = {
    isAllowedTo: () => true
};

const PermissionContext = React.createContext<PermissionContextType>(defaultBehaviour);

export default PermissionContext;
